import { useEffect, useState } from 'react';
import { useTranslation as useI18nTranslation } from 'react-i18next';
import { InternationalizationUtility } from '@/utils/internationalizationUtility';

/**
 * Custom translation hook that automatically re-renders when language changes
 * via the InternationalizationUtility service
 */
export const useTranslation = () => {
  const { t, i18n } = useI18nTranslation();
  const [, forceUpdate] = useState({});

  useEffect(() => {
    // Subscribe to language changes from the utility
    const unsubscribe = InternationalizationUtility.subscribe(() => {
      forceUpdate({}); // Force re-render
    });

    // Also listen to i18n changes as backup
    const handleLanguageChange = () => {
      forceUpdate({});
    };
    i18n.on('languageChanged', handleLanguageChange);

    return () => {
      unsubscribe();
      i18n.off('languageChanged', handleLanguageChange);
    };
  }, [i18n]);

  return { t, i18n };
};
